import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth';

import PaymentLinkV2Success from './PaymentLinkV2SuccessPage';

const PaymentLinkV2Route: FuseRouteItemType = {
  path: 'payment-link/v2/success',
  element: <PaymentLinkV2Success />,
  auth: AUTH_ROLES.user || AUTH_ROLES.onlyGuest,
};

export default PaymentLinkV2Route;
